import { useEffect, useRef, useState } from "react";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { IoTrash } from 'react-icons/io5'
import { Col, Container, Modal, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import * as Yup from 'yup'
import Swal from "sweetalert2";
import { viewImage } from "../CommonUtils/viewImage";
import { useDispatch } from "react-redux";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import { ERROR_MSG } from "../CommonUtils/contextVariables";
import { failureAlert } from "../CommonUtils/SweetAlerts";

export default function TeachingStaffDetailsReport() {
    const hasFetchedData = useRef(false)
        const userid = (sessionStorage.getItem('user_id') || "").startsWith('ffca_') ? sessionStorage.getItem('user_id').split('_')[1] : sessionStorage.getItem('user_id');
    const [data, setData] = useState([])
    const navigate = useNavigate()
    const [modal, setModal] = useState(false)
    const [row, setRow] = useState([])
    const dispatch = useDispatch()
    const validations = Yup.object({
        remarks: Yup.string().required(ERROR_MSG)
    })

    const formik = useFormik({
        initialValues: {
            remarks: ''
        },
        validationSchema: validations,
        onSubmit: () => {
            let payload = {
                empId: row?.original?.emp_id,
                remarks: formik.values.remarks
            }
            let url = config.url.API_URL + `DeleteEmployee`
            CommonAxiosPost(url, payload, dispatch).then((res) => {
                if (res.data.scode === '01') {
                    Swal.fire('Deleted Successfully', '', 'success').then((succ) => {
                        if (succ?.isConfirmed) {
                            window.location.reload()
                        }
                    })
                }
                else {
                    failureAlert("Failed to submit")

                }
            })
        }
    })
    function GetData() {
        let url = config.url.API_URL + `getEmpReport`+ "/"+userid;
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setData(res?.data?.EmpReport)

            }
        })
    }

    function handleDelete(row) {
        setRow(row)
        formik.setFieldValue('remarks', '')
        setModal(true)
    }

    function handleEdit(row, update) {
        sessionStorage.setItem('empId', row?.original?.emp_id)
        navigate('/AfflEmployeeDetails', { state: { update: update } })
    }


    const Columns = [
        {
            Header: "Sl.no",
            accessor: (row, index) => index + 1,
        },
        {
            Header: "Employee Name",
            accessor: "emp_name",
            Cell: ({ row }) => <div className="text-left">{row?.values?.emp_name ? row?.values?.emp_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: <>Date of Birth<br />/Gender</>,
            accessor: "dob",
            Cell: ({ row }) => <div>{row?.original?.dob}<br />({row?.original?.gender})</div>
        },
        {
            Header: "Aadhar",
            accessor: "aadhar",
            Cell: ({ row }) => <div style={{ width: '80px' }}>{row?.values?.aadhar ? row?.values?.aadhar : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "PAN No.",
            accessor: "pan_number",
            Cell: ({ row }) => <div style={{ width: '80px' }}>{row?.values?.pan_number ? row?.values?.pan_number : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Photo",
            accessor: "emp_photo",
            Cell: ({ row }) => <div>{row?.values?.emp_photo ? <button type="button" onClick={() => viewImage(row?.values?.emp_photo)} style={{ color: 'dodgerblue', cursor: 'pointer', textDecoration: 'underline' }}>View</button> : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: <>NET/SLET/SET<br />/Qualification<br />certificate</>,
            accessor: "qual_ets_view",
            Cell: ({ row }) => <div>{row?.values?.qual_ets_view ? <button type="button" onClick={() => viewImage(row?.values?.qual_ets_view)} style={{ color: 'dodgerblue', cursor: 'pointer', textDecoration: 'underline' }}>View</button> : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },


        {
            Header: "SSC H.No",
            accessor: "ssc_no",
            Cell: ({ row }) => <div>{row?.values?.ssc_no ? row?.values?.ssc_no : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: <>Employee type<br />/Designation type</>,
            accessor: "emp_type_name",
            Cell: ({ row }) => <div>{row?.values?.emp_type_name ? row?.values?.emp_type_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Designation",
            accessor: "designation_name",
            Cell: ({ row }) => <div>{row?.values?.designation_name ? row?.values?.designation_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Course and Combination",
            accessor: "course_cat_name",
            Cell: ({ row }) => <div>{row?.values?.course_cat_name ? row?.values?.course_cat_name : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Mobile No",
            accessor: "emp_mobileno",
            Cell: ({ row }) => <div style={{ width: '80px' }}>{row?.values?.emp_mobileno ? row?.values?.emp_mobileno : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: 'Action',
            Cell: ({ row }) => (
                <center>
                    <div className="d-flex justify-content-center">
                        <button
                            type="button"
                            onClick={() => handleDelete(row)}
                            className="btn btn-danger btn-sm me-2 print-hide"
                        >
                            <IoTrash />
                        </button>
                        <button
                            type="button"
                            onClick={() => handleEdit(row, "Update")}
                            className="btn btn-primary btn-sm print-hide"
                        >
                            <FaEdit />
                        </button>
                    </div>
                </center>
            ),

        }
    ]
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetData()
            hasFetchedData.current = true
        }
    }, [])
    const Navigatetonewentry = () => {
        navigate('/AfflEmployeeDetails', { state: { action: 'Submit' } });
        localStorage.removeItem('empId');
        formik?.resetForm();
    };
    return (
        <>
            <Modal show={modal} onHide={() => setModal(false)} style={{ marginTop: '15%' }} backdrop='static'>
                <FormikProvider value={formik}>
                    <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit}>
                        <Modal.Header style={{ backgroundColor: "#795A1D", color: "#fff" }} closeButton>
                            <Modal.Title>Enter Remarks</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                                    <div>Employee Name : <b >{row?.original?.emp_name}</b></div>
                                    <div>Date Of Birth : <b>{row?.original?.dob}</b></div>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                                    <div>Designation : <b>{row?.original?.designation_name || '-'}</b></div>
                                    <div>Mobile No : <b>{row?.original?.emp_mobileno}</b></div>
                                </Col>
                            </Row>
                            <Field as='textarea' name='remarks' rows='3' maxLength='1000'
                                className={`form-control ${formik.touched.remarks && formik.errors.remarks ? 'is-invalid' : ''}`} onBlur={formik.handleBlur} />
                            <ErrorMessage name='remarks' component='div' className='text-error' />
                            <button type='submit' className='btn btn-success btn-sm float-end mt-2 mb-2'>Submit</button>
                        </Modal.Body>
                    </Form>
                </FormikProvider>
            </Modal >

            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex justify-content-between align-items-center">
                <div className="inner-herbpage-service-title-sub pt-0"  >
                    <h1 className="m-0 p-0 pb-2">Teaching Staff Details Report</h1>
                </div>
                <div>
                    {/* <button type='button' className='btn btn-secondary btn-sm ml-auto' onClick={() => { navigate(-1); localStorage.removeItem('empId') }}>New Entry</button> */}

                    <button type='button' className='btn btn-secondary btn-sm ml-auto' onClick={Navigatetonewentry}>New Entry</button>

                    <button type='button' className='btn btn-secondary btn-sm ml-auto mx-1' onClick={() => navigate(-1)}>Back</button>
                </div>
            </Col>
            <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5 " style={{ backgroundColor: '#FAF7F0' }}  >
                {data && data?.length > 0 ? (
                    <CommonReactTable data={data} columns={Columns} excelFlag={false} printFlag={false} filename="Teaching Staff Details Report" headerName={`Teaching Staff Details Report`} />
                ) : (
                    <b className='text-error text-center'>No data Found</b>
                )}
            </Container>
        </>
    )
}
